export const showHelpPdf = (company) => {
    const url = localStorage.getItem('optimbtp_api_url') + '/api/fichier_aide_' + company +'.pdf';
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
};